import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { UpdateCommissionMessageComponent } from 'src/app/MessageClipboard/update-commission-message/update-commission-message.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Commission } from 'src/model/commission.model';
import { Loan } from 'src/model/loan.model';
import { LoanGroup } from 'src/model/loanGroup.model';
import { CommissionService } from 'src/services/commission.service';
import { LoanGroupService } from 'src/services/loan-group.service';

export interface LoanCommissionUser {
  companyCode: string,
  usernameList: string[]
}

@Component({
    selector: 'app-add-commission',
    templateUrl: './add-commission.component.html',
    styleUrls: ['./add-commission.component.scss'],
    standalone: false
})

export class AddCommissionComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructAPI = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private lgService = inject(LoanGroupService);
  private commissionService = inject(CommissionService);

  amount: number;
  assignee: string;
  @Input() loan: Loan;

  @Output() passEntry = new EventEmitter<any>();

  loanCommissionUserList: LoanCommissionUser[] = [];

  assignedCommisionList: Commission[] = [];
  disabledSubmit = false;
  previousAssignedCommission = 0;
  commissionLimit = 0;
  loanGroup: LoanGroup;

  async ngOnInit(): Promise<void> {
    this.getAllUser();
    this.assignedCommisionList = await this.commissionService.getLoanCommissions(this.loan.ID);
    this.previousAssignedCommission = this.assignedCommisionList.reduce((sum, c) => sum + c.Amount, 0);

    //need to include shared company's loan group, so need to use loangroups endpoint with filter showUninvolved=true
    const lgs = await this.lgService.getLoanGroups({ ids: [this.loan.LoanGroupId], showUninvolved: true });
    this.loanGroup = lgs[0];
    this.commissionLimit = this.loanGroup.CommissionRateLimit;
  }

  getAllUser() {
    const xhttp = this.restapi.getRequest(this.constructAPI.getLoanCommissionUsers(this.loan.ID))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const json = JSON.parse((xhttp.responseText))
        const userArray = json.users;
        userArray.forEach(json => {
          const user = json.username;

          const index = this.loanCommissionUserList.findIndex(commissionUser => commissionUser.companyCode == json.companyCode)

          if (index != -1)
            this.loanCommissionUserList[index].usernameList.push(user);
          else {
            const loanCommissionUser = { companyCode: json.companyCode, usernameList: [json.username] };
            this.loanCommissionUserList.push(loanCommissionUser);
          }

          // this.usernameList.push(user);
        });
      }
    };
  }

  checkNull() {
    return (this.amount == undefined) || (this.assignee == undefined) || isNaN(+this.amount)
  }

  submit() {
    if (this.checkNull() == false) {
      this.assignCommission();
    }
    else
      this.sharedService.openAlert("Please fill in amount and assignee!", ALERT_TYPE.DANGER)
  }

  assignCommission() {
    this.disabledSubmit = true;

    const data = {
      "amount": this.amount,
      "loanId": this.loan.ID,
      "assignee": this.assignee,
      "dateCreated": new Date().toISOString()
    };

    const xhr = this.restapi.postRequest(this.constructAPI.getAssignCommission(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          this.passEntry.emit();
          this.reset();
          this.sharedService.openAlert("Successfully added commission!", ALERT_TYPE.SUCCESS);
        }
        else {
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  openCommissionMessageModal() {
    const modalRef = this.sharedService.openModal(UpdateCommissionMessageComponent, "regularModal");
    modalRef.componentInstance.lgId = this.loan.LoanGroupId;
    modalRef.componentInstance.loan = this.loan;
    modalRef.componentInstance.loanId = this.loan.ID;
    modalRef.componentInstance.currentCommissionRate = this.commissionLimit;
  }

  reset() {
    this.activeModal.close();
  }
}
